import { render, staticRenderFns } from "./ShapeList.vue?vue&type=template&id=4d3b03e0&scoped=true&"
import script from "./ShapeList.vue?vue&type=script&lang=js&"
export * from "./ShapeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3b03e0",
  null
  
)

export default component.exports